import React from 'react'

import { createSvgIcon } from './utils/create-svg-icon'

export const CommentSmallIcon = createSvgIcon(
  <>
    <title></title>
    <g
      className="nc-icon-wrapper"
      fill="#222222"
      stroke="#222222"
      strokeLinecap="square"
      strokeLinejoin="miter"
      strokeWidth="4"
      transform="translate(0.5 0.5)"
    >
      <path
        d="M28,2H4A3,3,0,0,0,1,5V21a3,3,0,0,0,3,3h7l5,6,5-6h7a3,3,0,0,0,3-3V5A3,3,0,0,0,28,2Z"
        fill="none"
        stroke="#222222"
        strokeMiterlimit="10"
      />{' '}
      <line
        data-color="color-2"
        fill="none"
        strokeMiterlimit="10"
        x1="8"
        x2="24"
        y1="10"
        y2="10"
      />{' '}
      <line
        data-color="color-2"
        fill="none"
        strokeMiterlimit="10"
        x1="8"
        x2="17"
        y1="16"
        y2="16"
      />
    </g>
  </>
)
